var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "lesson-admin" },
    [
      _vm.adminMenu
        ? _c("AdminMenu", {
            staticClass: "admin-menu",
            attrs: {
              items: _vm.adminMenu.items,
              badges: _vm.adminMenu.badges,
              orientation: ["top", "left"]
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.shouldShowGoogleClassroomButton && _vm.isGoogleClassroomsReadyToRender
        ? _c("GoogleClassroomButton", {
            staticClass: "google-classroom-button-lesson",
            attrs: {
              "content-type": "lesson",
              "content-id": _vm.lesson.quiz_id,
              "content-title": _vm.lesson.name,
              "content-blurb": _vm.lesson.description_plain,
              "content-url": "" + _vm.baseUrl + _vm.lesson.link
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }